import React, { useState, useEffect, useRef } from 'react';
import { Phone, Menu, X } from 'lucide-react';

const Header = ({ navigateTo, currentPage }) => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isDesktop, setIsDesktop] = useState(false);
    const navRef = useRef(null);

    const checkIsDesktop = () => {
        setIsDesktop(window.innerWidth >= 768);
    };

    useEffect(() => {
        checkIsDesktop();
        window.addEventListener('resize', checkIsDesktop);
        return () => window.removeEventListener('resize', checkIsDesktop);
    }, []);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (navRef.current && !navRef.current.contains(event.target) && !isDesktop) {
                setIsMobileMenuOpen(false);
            }
        };
        if (isMobileMenuOpen && !isDesktop) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isMobileMenuOpen, isDesktop]);

    // Fonction de navigation à l'intérieur du Header
    const handleNavigate = (page) => {
        navigateTo(page);
        setIsMobileMenuOpen(false);
    };

    return (
        <header className="py-4 px-6 md:px-12 lg:px-24 border-b border-gray-800 relative bg-gray-900"> {/* Ajout de bg-gray-900 */}
            <div className="flex items-center justify-between">
                <div className="text-2xl font-bold text-white">Sev Remorque</div> {/* Changement de couleur du texte à blanc */}
                {!isDesktop && (
                    <button
                        variant="ghost"
                        size="icon"
                        onClick={toggleMobileMenu}
                        className="md:hidden text-white" // Changement de couleur de l'icône à blanc
                        aria-label="Toggle Mobile Menu"
                    >
                        {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
                    </button>
                )}
                {(isDesktop || isMobileMenuOpen) && (
                    <nav
                        ref={navRef}
                        className={`flex ${
                            isDesktop
                                ? 'flex-row items-center gap-4 md:gap-6 lg:gap-8'
                                : 'flex-col items-start gap-4 absolute top-full left-0 right-0 bg-gray-900/90 backdrop-blur-md py-4 px-6 z-10'
                        } ${!isDesktop && !isMobileMenuOpen ? 'hidden' : ''}`}
                    >
                        <button
                            onClick={() => handleNavigate('home')}
                            className={`hover:text-blue-500 transition-colors block py-2 px-4 text-white ${currentPage === 'home' ? 'font-bold' : ''}`} // Changement de couleur du texte à blanc
                        >
                            Acceuil
                        </button>
                        <button
                            onClick={() => handleNavigate('services')}
                            className={`hover:text-blue-500 transition-colors block py-2 px-4 text-white ${currentPage === 'services' ? 'font-bold' : ''}`} // Changement de couleur du texte à blanc
                        >
                            Services
                        </button>
                    </nav>
                )}
                <a
                    href="tel:0699463159"
                    className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-full transition-colors flex items-center gap-2
                    md:static absolute top-20 right-6"
                >
                    <Phone className="w-4 h-4" />
                    Appelez maintenant
                    <span className="font-bold">06 99 46 31 59</span>
                </a>
            </div>
        </header>
    );
};

export default Header;